import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../../index';
@Injectable()
export class UocTinhTonThatService {
  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService, private userService: UserService) { }

  layDDo_daunguon_cu(danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_TONTHAT.P_LAY_DIEMDAUNGUON" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

  layUoctinh(danhmucid, tungay, denngay, ddo_daunguon) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_TONTHAT.P_LAY_UOCTINH_TONTHAT" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_ddo_daunguon: ddo_daunguon,
        //v_sotrang: sotrang,
        //v_sodong: sodong
      })
    };

    return this.apiService.Excute(this.APIURL, param);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/uoc-tinh-ton-that/uoctinhtonthat.service.ts